export const fetchArticleSuggestions =
  ({ search }) =>
  async (_dispatch, _getState, { gccApiClient }) => {
    const data = await gccApiClient.getArticleSuggestions(search);
    return data;
  };
